import React, { useMemo, useState, useEffect } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import CruiseShipAmenitiesItem from './CruiseShipAmenitiesItem'
import CruiseShipAmenitiesTab from './CruiseShipAmenitiesTab'

const AmenitiesGrid = styled.div`
  display: grid;
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`

interface Props {
  ship: App.CruiseShip;
}

function CruiseShipAmenities({
  ship,
}: Props) {
  const [selectedAmenityCategory, setSelectedAmenityCategory] = useState<App.CruiseShipAmenityInfo | null>(null)

  const amenitiesByCategory = useMemo(() => {
    return (ship.shipInfo || [])
      .filter(info => !!info.amenityInfo)
      .map(info => info.amenityInfo as App.CruiseShipAmenityInfo)
  }, [ship.shipInfo])

  useEffect(() => {
    if (amenitiesByCategory.length) {
      setSelectedAmenityCategory(amenitiesByCategory[0])
    }
  }, [amenitiesByCategory])

  if (!amenitiesByCategory.length) {
    return null
  }

  return <Group direction="vertical" gap={16}>
    <Heading variant="heading3">Facilities</Heading>

    <HorizontalContainerWithFadedOverflow>
      <Group direction="horizontal" gap={16}>
        {amenitiesByCategory.map((amenityCategory) => (
          <CruiseShipAmenitiesTab
            key={`tab-amenity-${amenityCategory.title}`}
            amenityInfo={amenityCategory}
            isSelected={selectedAmenityCategory?.title === amenityCategory.title}
            onSelect={setSelectedAmenityCategory}
          />
        ))}
      </Group>
    </HorizontalContainerWithFadedOverflow>

    {!!selectedAmenityCategory && (
      <AmenitiesGrid>
        {selectedAmenityCategory.amenities.map((amenity) => (
          <CruiseShipAmenitiesItem key={`amenity-item-${amenity.title}`} amenity={amenity} />
        ))}
      </AmenitiesGrid>
    )}
  </Group>
}

export default CruiseShipAmenities
